
export class SocioDto {
	razonSocial: string;
	contacto: string;
	documento: string;
	complemento: string;
	email: string;
	celular: string;
	hasWhatsapp: boolean;
}
